const homeSelectedTabReducer = (state = "", action) => {
    switch (action.type) {
      case "SET_HOME_SELECTED_TAB":
        return action.payload;
      default:
        return state;
    }
  }
  export default homeSelectedTabReducer;